import { map } from 'ramda';
import qs from 'qs';

const { REACT_APP_NUCLEAR_MONITOR_API } = process.env;
const API_BASE = REACT_APP_NUCLEAR_MONITOR_API || 'http://localhost:3001';

async function doFetch(...args) {
  const res = await fetch(...args);

  if (!res.ok) {
    throw new Error('Fetch error');
  }
  return res;
}

export async function getRivers() {
  return Promise.all(
    ['garonne', 'loire', 'meuse', 'moselle', 'rhin', 'rhone', 'seine'].map(
      river =>
        fetch(`./rivers/${river}.json`)
          .then(res => res.json())
          .then(res => ({ ...res, name: river })),
    ),
  );
}

export async function getPlants() {
  const res = await doFetch(`${API_BASE}/plants`);
  const data = await res.json();

  return data;
}

export async function getUsNPPs() {
  const url = `${API_BASE}/us-npps`;
  console.info('[API] GET', url);
  const res = await doFetch(url);
  const data = await res.json();

  return data;
}

export async function getUsNppUnavailabilities({ year, plantId } = {}) {
  const url = `${API_BASE}/us-npps/unavailabilities?${qs.stringify({
    year,
    plantId,
  })}`;
  console.info('[API] GET', url);
  const res = await doFetch(url);
  const data = await res.json();

  return data;
}

export async function getUsNuclearOutage({ year, plantId } = {}) {
  const url = `${API_BASE}/us-npps/outage?${qs.stringify({ year, plantId })}`;
  console.info('[API] GET', url);
  const res = await doFetch(url);
  const data = await res.json();

  return data;
}

export async function getUsNppMonthlyProduction({ year, plantId } = {}) {
  const url = `${API_BASE}/us-npps/production?${qs.stringify({
    year,
    plantId,
  })}`;
  console.info('[API] GET', url);
  const res = await doFetch(url);
  const data = await res.json();

  return data;
}

export async function getUsNppSnapshot({ date } = {}) {
  const url = `${API_BASE}/us-npps/snapshot?${qs.stringify({ date })}`;
  console.info('[API] GET', url);
  const res = await doFetch(url);
  const data = await res.json();
  return data;
}

export async function getUsNppPlantLoads({ start, end } = {}) {
  const url = `${API_BASE}/us-npps/loads?${qs.stringify({ start, end })}`;
  console.info('[API] GET', url);
  const res = await doFetch(url);
  const data = await res.json();
  return data;
}

export async function getReactors() {
  const res = await doFetch(`${API_BASE}/reactors`);
  const data = await res.json();

  return data;
}

export async function getProductions({ date }) {
  const res = await doFetch(
    `${API_BASE}/productions?${qs.stringify({ date })}`,
  );
  const data = await res.json();

  console.log('[getProductions] API response:', data);

  return data;
}

export async function getUnavailabilities({ date }) {
  const res = await doFetch(
    `${API_BASE}/unavailabilities?${qs.stringify({
      date,
    })}`,
  );
  const data = await res.json();

  console.log('[getUnavailabilities] API response:', data);

  return data;
}

export async function getNextUnavailabilities(input) {
  const res = await doFetch(
    `${API_BASE}/unavailabilities/next/?${qs.stringify(input)}`,
  );
  const data = await res.json();

  return data;
}

export async function getFinishedUnavailabilities(input) {
  const res = await doFetch(
    `${API_BASE}/unavailabilities/finished/?${qs.stringify(input)}`,
  );
  const data = await res.json();

  return data;
}

export async function getMix({ date }) {
  const res = await doFetch(`${API_BASE}/mix?${qs.stringify({ date })}`);
  const data = await res.json();

  console.log('[getMix] Raw API response:', data);

  const { mix } = data;
  if (!Array.isArray(mix) || mix.length < 1) {
    console.warn('[getMix] Invalid or empty mix data:', mix);
    return { date: data.date, mix: [] };
  }

  const rest = Array.from({ length: 25 * 4 - mix.length }).map(() =>
    map(() => NaN, mix[0]),
  );

  return {
    date: data.date,
    mix: mix.concat(rest),
  };
}
